// extracted by mini-css-extract-plugin
export default {"content":"content--FcEQH","title":"title--EbKAx","text":"text--FgTpK","btn":"btn--JHw_e","btnItem":"btnItem--tIxP8","icon":"icon--wo9EG","txt":"txt--gDUcn","switch":"switch--D62Wi"};